module.exports = __webpack_public_path__ + "img/process-02.1fcbba0f.png";